function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
export var ShadowOverlay = styled.div.withConfig({
  displayName: "ShadowEffect__ShadowOverlay",
  componentId: "xkvm0o-0"
})(["display:block;position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(51,51,51,0.65);z-index:", ";"], function (props) {
  return props.zIndex;
});

function ShadowEffect(_ref) {
  var shouldCloseOnBlur = _ref.shouldCloseOnBlur,
      shouldOpenOnFocus = _ref.shouldOpenOnFocus,
      zIndex = _ref.zIndex,
      children = _ref.children,
      onClose = _ref.onClose,
      onOpen = _ref.onOpen,
      props = _objectWithoutProperties(_ref, ["shouldCloseOnBlur", "shouldOpenOnFocus", "zIndex", "children", "onClose", "onOpen"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var child = React.Children.only(children);

  var handleOpen = function handleOpen() {
    onOpen && onOpen();
    setOpen(true);
  };

  var handleClose = function handleClose() {
    onClose && onClose();
    setOpen(false);
  };

  var handleKeyDown = function handleKeyDown(evt) {
    var key = evt.key;

    if (key === 'Escape') {
      evt.preventDefault();
      handleClose();
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, isOpen && /*#__PURE__*/React.createElement(ShadowOverlay, _extends({
    zIndex: zIndex,
    onClick: handleClose
  }, props)), /*#__PURE__*/React.cloneElement(child, {
    style: {
      position: 'relative',
      zIndex: isOpen && zIndex
    },
    onBlur: function onBlur() {
      var onBlur = child.props.onBlur;
      onBlur && onBlur();
      shouldCloseOnBlur && handleClose();
    },
    onClick: function onClick() {
      var onClick = child.props.onClick;
      onClick && onClick();
      handleOpen();
    },
    onFocus: function onFocus() {
      var onFocus = child.props.onFocus;
      onFocus && onFocus();
      shouldOpenOnFocus && handleOpen();
    },
    onKeyDown: function onKeyDown(evt) {
      var onKeyDown = child.props.onKeyDown;
      onKeyDown && onKeyDown(evt);
      handleKeyDown(evt);
    }
  }));
}

ShadowEffect.propTypes = {
  shouldCloseOnBlur: PropTypes.bool,
  shouldOpenOnFocus: PropTypes.bool,
  zIndex: PropTypes.number,
  children: PropTypes.node,
  onClose: PropTypes.func,
  onOpen: PropTypes.func
};
ShadowEffect.defaultProps = {
  zIndex: 10
};
export default ShadowEffect;